<template>
  <div class="news-detail">
    <div class="news-detail-wrap" v-loading="loading">
      <div class="container">
        <div class="news-detail-panel">
          <h2 class="news-title">{{ newsIdList.Title }}</h2>
          <p class="news-meta">
            <span>发布时间：{{ formatDate(newsIdList.CreateTime) }}</span>
            <span class="dot">·</span>
            <span>来源：湖南中云图</span>
          </p>
          <div class="rich-body" v-html="newsIdList.Content"></div>
          <div class="news-actions">
            <router-link to="/news" class="back-link">&lt; 返回资讯列表</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetails",
  data() {
    return {
      loading: true,
      pid: 0,
      newsIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      const t = new Date(value);
      if (Number.isNaN(t.getTime())) return value;
      const m = `${t.getMonth() + 1}`.padStart(2, "0");
      const d = `${t.getDate()}`.padStart(2, "0");
      return `${t.getFullYear()}-${m}-${d}`;
    },
    loadData() {
      this.loading = true;
      this.$http
        .get(`News/${this.pid}`)
        .then(response => {
          this.newsIdList = response.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.news-detail {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.news-detail-wrap {
  padding: 28px 0 0;
}

.news-detail-panel {
  background: #fff;
  border: 1px solid $color-border;
  padding: 36px 40px;
  max-width: 1000px;
  margin: 0 auto;

  .news-title {
    margin: 0 0 8px;
    font-size: 26px;
    color: $color-text;
    font-weight: 600;
    line-height: 1.4;
    border-left: 4px solid $color-accent;
    padding-left: 14px;
  }

  .news-meta {
    margin: 0 0 24px;
    color: $color-text-3;
    font-size: 13px;
    border-bottom: 1px dashed $color-border;
    padding-bottom: 14px;

    .dot {
      margin: 0 8px;
      color: $color-border-dark;
    }
  }

  .rich-body {
    margin-top: 18px;
    color: $color-text;
    font-size: 14px;
    line-height: 1.85;

    & ::v-deep h2 {
      margin: 24px 0 10px;
      color: $color-text;
      font-size: 20px;
      font-weight: 600;
    }

    & ::v-deep h3 {
      margin: 18px 0 8px;
      color: $color-primary;
      font-size: 17px;
    }

    & ::v-deep img {
      display: block;
      max-width: 100%;
      height: auto;
      margin: 14px auto;
      border: 1px solid $color-border;
    }

    & ::v-deep p {
      margin: 0 0 12px;
    }
  }

  .news-actions {
    margin-top: 32px;
    padding-top: 18px;
    border-top: 1px solid $color-border;
  }

  .back-link {
    color: $color-accent;
    text-decoration: none;
    font-size: 14px;

    &:hover { text-decoration: underline; }
  }
}

@media (max-width: 720px) {
  .news-detail-panel {
    padding: 22px 18px;
  }

  .news-title { font-size: 20px; }
}
</style>
